import { OCCASION_MAP } from './brand-config'

export const getFacetKeyFromOccasion = (occasion: string): string => {
  const occasionData = OCCASION_MAP[occasion]
  return occasionData ? occasionData.facetKey : 'not-found'
}

export const getLabelFromOccasion = (occasion: string): string => {
  const occasionData = OCCASION_MAP[occasion]
  return occasionData ? occasionData.label : 'not-found'
}
